const clean = (value) => String(value ?? "").trim();

export const prepareStudentCreationCommand = (source = {}) => {
  const payload = { ...(source || {}) };
  const joiningDate = clean(payload.joiningDate || payload.joining_date);
  const requestIdentity = clean(
    payload.idempotencyKey ||
      payload.studentTempRef ||
      payload.student_temp_ref,
  );

  if (!joiningDate) throw new Error("Joining date is required.");
  if (!requestIdentity)
    throw new Error("Student creation reference is required.");
  payload.joiningDate = joiningDate;
  delete payload.schoolTimezone;
  delete payload.school_timezone;

  return {
    payload,
    idempotencyKey:
      clean(payload.idempotencyKey) || `student-create:${requestIdentity}`,
  };
};
